import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6077306e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "svg-inline",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<rect x=\"3\" y=\"6\" width=\"18\" height=\"15\" rx=\"2\" stroke=\"currentColor\" stroke-width=\"2\" data-v-6077306e></rect><path d=\"M4 11H20\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" data-v-6077306e></path><path d=\"M9 16H15\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" data-v-6077306e></path><path d=\"M8 3L8 7\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" data-v-6077306e></path><path d=\"M16 3L16 7\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" data-v-6077306e></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7))
}